module.exports = __webpack_public_path__ + "img/39.524ea40b.webp";